import { render, staticRenderFns } from "./DeleteGenreModal.vue?vue&type=template&id=777856fd&scoped=true&"
import script from "./DeleteGenreModal.vue?vue&type=script&lang=js&"
export * from "./DeleteGenreModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteGenreModal.vue?vue&type=style&index=0&id=777856fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777856fd",
  null
  
)

export default component.exports